module.exports = __webpack_public_path__ + "static/video-movie-2c1e114f295f47366778ab70615e1616.mp4";